export type ArtistBioType = {
	title: string
	description: string
	website?: string
	xHandle?: string
	imageUrl?: string
}

export type CollectionTokenRangeType = {
	type: 'smartContractRange'
	chain: string
	contract: string
	tokenStart: string
	tokenEnd: string
	inputSelector?: string
}
export type CollectionTokenIDsType = {
	type: 'smartContractIDs'
	chain: string
	contract: string
	tokenIDs: string[]
	inputSelector?: string
}
export type CollectionContractFullType = {
	type: 'smartContractFull'
	chain: string
	contract: string
	inputSelector?: string
}

export type CollectionNFTInputType =
	| CollectionTokenRangeType
	| CollectionTokenIDsType
	| CollectionContractFullType
export type SmartConractFullValue = { [chain: string]: string[] }
export type SmartContractRangeValue = {
	[chain: string]: {
		contract: string
		ranges: { tokenStart: string; tokenEnd: string }[]
	}[]
}
export type SmartContractIDsValue = {
	[chain: string]: { contract: string; tokenIDs: string[] }[]
}
export type NftIdsValue = string[]

export type CollectionNFTReferenceKey =
	| 'smartContractFull'
	| 'smartContractRange'
	| 'smartContractIDs'
	| 'nftIds'
export type CollectionNFTReferenceValue =
	| SmartConractFullValue
	| SmartContractRangeValue
	| SmartContractIDsValue
	| NftIdsValue

export type CollectionNFTReference = {
	smartContractFull?: SmartConractFullValue
	smartContractRange?: SmartContractRangeValue
	smartContractIDs?: SmartContractIDsValue
	nftIds?: NftIdsValue
}

export const CollectionNFTInputTypeNameMap = {
	smartContractFull: 'Full Contract',
	smartContractRange: 'Contract Range',
	smartContractIDs: 'Token List',
	nftIds: 'Token List',
	marketplaceCollection: 'Marketplace Collection',
}

export type CollectionType = {
	name: string
	slug: string
	description: string
	url?: string
	imageUrl?: string
	date?: string
	nfts: CollectionNFTInputType[]
	GroupNFTsCID?: string
	marketplaceUrls?: string
	web2URL?: string
}

export type CommentType = {
	title: string
	description: string
}

export type MediaCitationType = {
	name: string
	url: string
	description?: string
	publisher?: string
	date?: string
	author?: string
}

export type OffchainLendType = {
	startDate: string
	endDate: string
	ownerAddress?: string
	receiverAddress?: string
	countersignRequired?: boolean
	countersignStatus?: 'Pending' | 'Completed' | 'Accepted'
	amount?: number
	currency?: string
	description?: string
}

export type OffchainSaleType = {
	date: string
	ownerAddress?: string
	receiverAddress?: string
	countersignRequired?: boolean
	countersignStatus?: 'Pending' | 'Completed' | 'Accepted'
	amount?: number
	currency?: string
	description?: string
	transactionHash?: string
	url?: string
}

export type ProofOfExhibitionType = {
	startDate: string
	endDate: string
	name: string
	location?: string
	ownerAddress: string
	receiverAddress: string
	countersignRequired?: boolean
	artistInitiated?: boolean
	countersignStatus?: 'Pending' | 'Completed' | 'Accepted'
	description?: string
	url?: string
	imageUrl?: string
}

export type CountersignType = {
	description?: string
	originalMetadataIPFSCID: string
	originalAttestationIPFSCID: string
}

export type RevokeType = {
	description?: string
	originalMetadataIPFSCID: string
	originalAttestationIPFSCID: string
}

export type TweetType = {
	description?: string
	url?: string
	timestamp?: string
	ipfsCID: string
	arweaveTxId: string
	web2URL?: string
	user?: string
	content?: string
}

export type CastType = {
	description?: string
	url?: string
	timestamp?: string
	ipfsCID: string
	arweaveTxId: string
}

export type InstagramType = {
	description?: string
	url?: string
	timestamp?: string
	ipfsCID: string
	arweaveTxId: string
}

export type MediaType = {
	title?: string
	description?: string
	fileType: string
	fileExtension: string
	fileSize: number
	arweaveTxId: string
	web2URL: string
}

export type RollupType = {
	rollupCID: string
}

export type TemplateTypes =
	| 'ArtistBio'
	| 'Collection'
	| 'Comment'
	| 'MediaCitation'
	| 'OffchainLend'
	| 'OffchainSale'
	| 'ProofOfExhibition'
	| 'Countersign'
	| 'Revoke'
	| 'Tweet'
	| 'Cast'
	| 'Instagram'
	| 'Media Upload'
	| 'Rollup'
